import RangeSliderTwoHandles from "@Components/RangeSlider/RangeSliderTwoHandles";
import { FilterComponentProps } from "@Pages/Search/components/FilterSection/components/ActiveFilterComponent/types";
import useBudgetFilter from "@Pages/Search/components/FilterSection/components/Filters/Budget/useBudgetFilter";
import { AppState } from "@Store/index";
import { useSelector } from "react-redux";
import styles from "./budget.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import wrapperHOC from "@Utils/wrapperHOC";
import { useMemo } from "react";
import currencyData from "constants/currencyConstants";

const Budget = ({
  value,
  dispatch,
  onApplyClick,
  minAvailablePrice,
  maxAvailablePrice,
}: FilterComponentProps<string | string[]>) => {
  const { region, currencyExchangeRates } = useSelector(
    ({ searchPageData, appData }: AppState) => ({
      region: searchPageData?.region,
      currencyExchangeRates: appData.currencyExchangeRates,
    }),
  );

  const {
    initValue1,
    initValue2,
    value1,
    value2,
    priceDetails,
    handleOnChange,
    handleOnDragEnd: onDragEndFromHook,
  } = useBudgetFilter({
    region,
    value,
    dispatch,
    onApplyClick,
    minAvailablePrice,
    maxAvailablePrice,
    isInlineFilters: true,
  });

  const handleOnDragEnd = (values?: [number, number]) => {
    gtagEventEmitter({
      action: "SP_filter_subsection_filter_value_selected",
      category: "SP_filter_subsection",
      value: "Budget",
    });
    onDragEndFromHook(values);
  };

  const budgetFilterText = useMemo(() => {
    try {
      const baseCurrency = currencyExchangeRates?.baseCurrency;
      if (!baseCurrency) {
        return `${priceDetails.currency}${value1} - ${priceDetails.currency}${value2}`;
      }

      const currentCurrency = currencyData.find(
        (c) =>
          c.symbol === priceDetails.currency ||
          c.standard_name === priceDetails.currency ||
          c.short_name === priceDetails.currency,
      );

      const userCurrency = currencyData.find((c) => c.standard_name === baseCurrency);

      const exchangeRate = currencyExchangeRates.rates?.find((item: any) => {
        const target = item.target_currency.toLowerCase();
        return (
          target === currentCurrency?.standard_name?.toLowerCase() ||
          target === currentCurrency?.short_name?.toLowerCase()
        );
      });

      if (!exchangeRate?.rate) {
        return `${priceDetails.currency}${value1} - ${priceDetails.currency}${value2}`;
      }

      const convertedValue1 = Math.ceil(value1 / exchangeRate.rate);
      const convertedValue2 = Math.ceil(value2 / exchangeRate.rate);

      return `${userCurrency?.symbol}${convertedValue1} - ${userCurrency?.symbol}${convertedValue2}`;
    } catch (error) {
      return `${priceDetails.currency}${value1} - ${priceDetails.currency}${value2}`;
    }
  }, [currencyExchangeRates, currencyData, priceDetails.currency, value1, value2]);

  return (
    <div className={styles.rangeContainer}>
      <RangeSliderTwoHandles
        min={0}
        max={priceDetails.max - priceDetails.min}
        step={priceDetails.step}
        valueOne={initValue1 - priceDetails.min}
        valueTwo={initValue2 - priceDetails.min}
        handleOnChange={handleOnChange}
        handleOnDragEnd={handleOnDragEnd}
        // openingSource="filtersModalDesktop" // just to apply styles similar to desktop modal
      />
      <div className={styles.priceText}>{budgetFilterText}</div>
    </div>
  );
};

export default wrapperHOC(Budget, {
  componentName: "Budget-FilterSubsection-SearchListDesktop-SearchPage",
  showForChina: true,
});
